export class MainMenuVM {
    items: MenuItemVM[] = [];
}

export interface MenuItemVM {
    label: string;
    selected?: boolean;
}
